import React, {
  Fragment,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../store';
import { TTRestaurantProfile } from '../../../interfaces/restaurant';
import { GuestAddress, TTUserProfile } from '../../../interfaces/user';
import { RootState } from '../../../rootReducer';
import Input from '../../components/Input';
import PillLabel from '../../../components/PillLabel';
import {
  setFulfillmentDetails,
  setPickupDetails,
  setTableNumber,
} from '../../../features/cart/cart';
import { setFirstName, setUserProfile } from '../../../features/auth/auth';
import { guestApi } from '../../../api/guest';
import {
  OrderFulfillmentPickupDetailsCreate,
  TTOrderFulfillmentCreate,
} from '../../../interfaces/order';
import { CheckoutContext } from '../../Providers/CheckoutContext';
import { PickupSchedulingSlot } from './PickupSchedulingSlots';
import { ScheduledOrderTime } from './ScheduledOrderTime';
import { Dialog, Transition } from '@headlessui/react';

type Props = {
  restaurant_id: string;
};

export function PickupOrderDetails({ restaurant_id }: Props) {
  const restaurant_profile = useSelector<RootState, TTRestaurantProfile | null>(
    state => state.restaurant.profile,
  );

  const currentCheckout = useContext(CheckoutContext);

  const guest = useSelector<RootState, TTUserProfile | null>(
    state => state.auth.userProfile,
  );

  const order_fulfillment = useSelector<
    RootState,
    { [key: string]: TTOrderFulfillmentCreate }
  >(state => state.cart.fulfillment_details ?? {});

  const pickup_details = useSelector<
    RootState,
    OrderFulfillmentPickupDetailsCreate
  >(state => state.cart.pickup_details);

  const [showSchedulingSlots, setShowSchedulingSlots] = useState(false);

  const dispatch = useAppDispatch();
  const [name, setName] = useState('');

  const [showScheduling, setShowScheduling] = useState(false);

  const [comment, setComment] = useState('');

  useEffect(() => {}, [restaurant_profile]);

  useEffect(() => {
    if (
      currentCheckout &&
      currentCheckout.enabled &&
      currentCheckout.scheduled_ordering_enabled
    ) {
      setShowSchedulingSlots(true);
    }
  }, [currentCheckout]);

  useEffect(() => {
    if (guest !== null) {
      if (guest?.first_name !== null) {
        setName(guest.first_name + (' ' + (guest?.last_name ?? '')));
        dispatch(setTableNumber(`P_${guest?.first_name?.split(' ')[0]}`));
      }
      if (order_fulfillment[restaurant_id] === undefined) {
        dispatch(
          setFulfillmentDetails({
            [restaurant_id]: {
              guest_id: guest?.id,
              type: 'pick_up',
              order_item_application: 'all_items',
              pickup_details: {
                guest_id: guest?.id,
                schedule_type: currentCheckout?.scheduled_ordering_enabled
                  ? 'scheduled'
                  : 'asap',
                note: '',
              },
            },
          }),
        );
      } else {
        dispatch(
          setFulfillmentDetails({
            [restaurant_id]: {
              ...order_fulfillment[restaurant_id],
              type: 'pick_up',
              catering_details: null,
              delivery_details: null,
            },
          }),
        );
      }
      if (pickup_details === null || pickup_details === undefined) {
        dispatch(
          setPickupDetails({
            [restaurant_id]: {
              guest_id: guest?.id,
              schedule_type: currentCheckout?.scheduled_ordering_enabled
                ? 'scheduled'
                : 'asap',
            },
          }),
        );
        dispatch(
          setFulfillmentDetails({
            [restaurant_id]: {
              ...order_fulfillment[restaurant_id],
              pickup_details: {
                guest_id: guest?.id,
                schedule_type: currentCheckout?.scheduled_ordering_enabled
                  ? 'scheduled'
                  : 'asap',
              },
              catering_details: null,
              delivery_details: null,
              guest_id: guest?.id,
              type: 'pick_up',
            },
          }),
        );
      } else {
        dispatch(
          setFulfillmentDetails({
            [restaurant_id]: {
              ...order_fulfillment[restaurant_id],
              pickup_details: {
                ...pickup_details[restaurant_id],
                schedule_type: currentCheckout?.scheduled_ordering_enabled
                  ? 'scheduled'
                  : 'asap',
              },
              catering_details: null,
              delivery_details: null,
              guest_id: guest?.id,
              type: 'pick_up',
            },
          }),
        );
      }
    }
  }, [guest]);

  return (
    <>
      {restaurant_profile !== null && pickup_details && (
        <div className="mx-4 my-2">
          <fieldset>
            {
              <>
                <div className={'flex flex-col'}>
                  <div className="flex flex-row justify-left content-center items-center mb-2 mt-4">
                    <label className=" block uppercase tracking-wide text-on-surface text-sm font-bold">
                    Full Name
                    </label>
                    <div className="text-gray-900 items-center text-sm text-right -mt-1 ml-2">
                      <PillLabel
                        color="bg-error-container"
                        text_color="text-on-error-container"
                        label="Required"
                      />
                    </div>
                  </div>
                </div>
                <div className="py-2   sm:h-1/5 max-h-1/5 sm:flex rounded bg-surface">
                  <div className="p-4 flex felx-row w-full rounded-lg  justify-between bg-primary/10">
                    <Input
                      // @ts-ignore
                      handleChange={e => {
                        setName(e.target.value);
                      }}
                      handleBlur={async e => {
                        // dispatch(setPickUpName(e.target.value));
                        dispatch(setFirstName(e.target.value?.split(' ')[0]));

                        dispatch(
                          setTableNumber(`CT_${e.target.value?.split(' ')[0]}`),
                        );

                        try {
                          const guestNameResponse = await guestApi.updateGuest(
                            {
                              first_name: e.target.value?.split(' ')[0],
                              last_name:
                                e.target.value?.split(' ')?.length > 1
                                  ? e.target.value?.split(' ')[1]
                                  : '',
                            },
                            guest?.id,
                          );
                          dispatch(setUserProfile(guestNameResponse.data));
                        } catch (e) {}
                      }}
                      name="name"
                      value={name}
                      className="appearance-none bg-surface-variant block w-full px-3 py-2 border border-outline-variant rounded-md placeholder-on-surface/60 focus:ring-primary/70 focus:border-primary text-on-surface transition duration-150 ease-in-out text-md sm:leading-5"
                      type="text"
                      autoComplete="off"
                      placeholder=""
                    />
                  </div>
                </div>
                {currentCheckout?.scheduled_ordering_enabled ? (
                  <>
                    <div className="flex flex-row justify-left content-center items-start mb-2 mt-4">
                      <legend className=" block uppercase tracking-wide text-on-surface text-sm font-bold">
                        Date & Time
                      </legend>
                    </div>
                    <ScheduledOrderTime
                      scheduled_for={
                        pickup_details
                          ? pickup_details[restaurant_id]?.scheduled_for ?? ''
                          : ''
                      }
                      className=""
                      onClick={() => {
                        setShowScheduling(true);
                      }}
                    />
                  </>
                ) : (
                  <></>
                )}

                {/* <div className={'h-0.5 w-8/10 bg-gray-900 my-4 mx-auto'} /> */}

                <div className="flex flex-row justify-left content-center items-start mb-2 mt-4">
                  <legend className=" block uppercase tracking-wide text-on-surface text-sm font-bold">
                    Comments
                  </legend>
                </div>
                <div className="mt-1">
                  <textarea
                    rows={2}
                    name="comment"
                    id="comment"
                    onChange={e => {
                      setComment(e?.target?.value);
                      dispatch(
                        setPickupDetails({
                          [restaurant_id]: {
                            ...pickup_details[restaurant_id],
                            note: e.target.value,
                          },
                        }),
                      );
                      dispatch(
                        setFulfillmentDetails({
                          [restaurant_id]: {
                            ...order_fulfillment[restaurant_id],
                            pickup_details: {
                              ...pickup_details[restaurant_id],
                              note: e.target.value,
                            },
                          },
                        }),
                      );
                    }}
                    value={
                      comment?.length !== 0
                        ? comment
                        : pickup_details[restaurant_id]?.note ?? ''
                    }
                    className="appearance-none bg-surface-variant block w-full px-3 py-2 border border-outline-variant rounded-md placeholder-on-surface-variant/60 focus:ring-primary/70 focus:border-primary text-on-surface-variant transition duration-150 ease-in-out text-md sm:leading-5"
                  />
                </div>
              </>
            }
          </fieldset>
        </div>
      )}

      {showScheduling ? (
        <>
          <Transition.Root show={showScheduling} as={Fragment} appear>
            <Dialog as="div" className="relative z-10" onClose={() => {}}>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
                afterLeave={() => {
                  setShowScheduling(false);
                }}
              >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
              </Transition.Child>

              <div className="fixed inset-0 z-10 overflow-y-auto">
                <div className="flex min-h-screen items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  >
                    <Dialog.Panel className="relative transform overflow-auto rounded-lg bg-surface px-2 pt-2 pb-2 text-left shadow-xl transition-all  w-full h-screen">
                      <div className="p-4 md:p-8 lg:px-16 relative">
                        <h3 className="text-on-surface text-lg font-semibold">
                          Select Date & Time for Your Order
                        </h3>
                        <div className="mt-4">
                          <PickupSchedulingSlot
                            onSelect={() => {
                              setShowScheduling(false);
                            }}
                            fromCheckout={true}
                            onCancel={() => {
                              setShowScheduling(false);
                            }}
                          />
                        </div>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition.Root>
        </>
      ) : (
        <></>
      )}
    </>
  );
}
